export enum FeedbackWarningColorToken {
  feedbackColorWarningPure = '#FCC23D',
  feedbackColorWarningLight = '#FFFDE8',
  feedbackColorWarningMedium = '#FBB209',
  feedbackColorWarningDark = '#F38329',
}

export default FeedbackWarningColorToken

export type TWarning =
  | 'feedbackColorWarningPure'
  | 'feedbackColorWarningLight'
  | 'feedbackColorWarningMedium'
  | 'feedbackColorWarningDark'
